<template>
  <div>
    <common-dialog width="80%" :visible.sync="dialog.dialogVisible" @close="handleCloseDialog">
      <div class="dialog-title" slot="title">
        <template>
          <div class="post-title" >{{ dialog.form.postTitle }}</div>
        </template>
      </div>
      <div class="dialog-body" style="font-size: 16px;line-height: 30px">
        <div style="text-align:right; overflow: auto;">
          <div class="post-userName">{{ dialog.form.userName }}</div>
          <div class="post-time">{{ dialog.form.createTm | dateFormat }}</div>
        </div>
        <div class="post-content" v-html="dialog.form.postContent"/>
        <div class="post-rejectReason" v-if="dialog.form.rejectReason">
          <div style="overflow: auto">被拒原因 : {{ dialog.form.rejectReason }}</div>
          <div style="color: gray;font-size:14px; padding-top: 5px">审核人：{{ dialog.form.approveUserName}}
            <span style="float: right">审核时间：{{ dialog.form.lastModTm | dateFormat }}</span></div>

        </div>
      </div>
      <div class="dialog-footer" slot="footer">
        <common-button type="cancel" @click="dialog.dialogVisible = false">取消</common-button>
      </div>
    </common-dialog>

    <animation :loadingDataVisible="dialog.isLoading" loadingText="加载中"></animation>
  </div>
</template>

<script>
import cookie from "@/utils/cookie";
import http from '@/utils/axios'
import animation from '@/components/loading/animation'

export default {
  name: "PostDetail",
  components: {animation},
  data() {
    return {
      dialog: {
        dialogVisible: false,
        isLoading: false,
        form: {},
      }
    }
  },

  props: {
    baseUrl: {
      type: String,
      default: null,
    },

    postCode: {
      type: String,
      default: null,
    },

    status: {
      type: String,
      default: null,
    },
  },

  mounted() {
    this.dialog.dialogVisible = true
    this.queryData()
  },

  methods: {
    handleCloseDialog() {
      this.$emit("handlerVisible", false)
    },

    queryData() {
      let _this = this;
      this.dialog.isLoading = true;
      http.post(window.config.api.baseUrl + this.baseUrl, {
        token: cookie.getCookie("token"),
        data: {
          postCode: _this.postCode,
          status: _this.status,
        }
      }).then((response) => {
        let data = response.data.data;
        _this.dialog.form = data.article;
        //当拒绝原因为空时
        if(_this.dialog.form.status=='2'&&_this.dialog.form.rejectReason==''){
          _this.dialog.form.rejectReason=" ";
        }
      }).finally(() => {
        _this.dialog.isLoading = false;
      })
    }



  }
}
</script>

<style scoped>
  .post-title{
    width: 60%;
    display: inline-block;
  }
.post-userName{
  font-size: 14px;
  color: #a6a6a6;
}

.post-time{
  font-size: 14px;
  color: #888888;
}

.post-content{
  height: 40vh;
  overflow: auto;
  text-indent: 2em;
}
  .post-rejectReason{
    color: #212121;
    height: 30px;
    font-size: 16px;
    line-height: 20px;
    /*overflow: auto;*/

  }
</style>



// WEBPACK FOOTER //
// src/components/detail/PostDetail.vue